import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _defineProperty from "@babel/runtime-corejs2/helpers/esm/defineProperty";
import { SessionServiceStateType } from '@central-products/interface-session-service';
import { canDisableTriggerLogin } from './utils';
export var LOGIN_TRIGGER = 'LOGIN';

var OnSiteMessagingTriggerLogin = /*#__PURE__*/function () {
  function OnSiteMessagingTriggerLogin(config, dependencies) {
    var _this = this;

    _classCallCheck(this, OnSiteMessagingTriggerLogin);

    _defineProperty(this, "onSiteMessagingComponent", void 0);

    _defineProperty(this, "sessionService", void 0);

    _defineProperty(this, "disableLogin", void 0);

    _defineProperty(this, "processSessionState", function (_ref) {
      var state = _ref.state;

      if (canDisableTriggerLogin(_this.disableLogin)) {
        return;
      }

      if (state === SessionServiceStateType.SESSION_EXISTS) {
        _this.onSiteMessagingComponent.requestMessage({
          trigger: LOGIN_TRIGGER
        });
      }
    });

    this.sessionService = dependencies['session-service'];
    this.onSiteMessagingComponent = dependencies['on-site-messaging-component'];
    this.disableLogin = config.disableLogin;
  }

  _createClass(OnSiteMessagingTriggerLogin, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var sessionState;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.sessionService.getState();

              case 2:
                sessionState = _context.sent;
                this.processSessionState(sessionState);
                this.sessionService.onStateChanged(this.processSessionState);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return OnSiteMessagingTriggerLogin;
}();

export default OnSiteMessagingTriggerLogin;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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